import { render, staticRenderFns } from "./myManageItem.vue?vue&type=template&id=2b57750b&scoped=true"
import script from "./myManageItem.vue?vue&type=script&lang=js"
export * from "./myManageItem.vue?vue&type=script&lang=js"
import style0 from "./myManageItem.vue?vue&type=style&index=0&id=2b57750b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b57750b",
  null
  
)

export default component.exports